/**
 * File: tourContentData.ts
 * Path: apps/admin/src/shared/utils/tourContentData.ts
 * Description: The one list of tutorials. The ?
 * in every page header opens a Help dialog listing the tutorials for that
 * page; each one runs alone as a short spotlight tour. A tutorial is one
 * task (verb first), 2 to 5 steps, each step at most 300 characters in
 * simple words. Every step points at something on a page with a CSS
 * selector. The words live in accountingTutorialsData.ts (Money build) and
 * crmTutorialsData.ts / siteTutorialsData.ts (Admin build).
 */

import type { Tutorial } from "./tutorialTypes";
import { ACCOUNTING_TUTORIALS } from "./accountingTutorialsData";
import { CRM_TUTORIALS } from "./crmTutorialsData";
import { SITE_TUTORIALS } from "./siteTutorialsData";


export const TUTORIALS: Tutorial[] = [...ACCOUNTING_TUTORIALS, ...CRM_TUTORIALS, ...SITE_TUTORIALS];
